import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  InputsModule,
  GroupDropdownModule,
  CheckboxModule,
  ButtonModule,
  TooltipModule as XrefTooltipModule
} from '@xref/xref-lib';
import {LoaderModule} from "src/app/components/loader/loader.module";
import { InsightsFilterModalComponent } from './insights-filter-modal.component';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AppPaginationModule } from 'src/app/components/pagination/pagination.module';


@NgModule({
  declarations: [InsightsFilterModalComponent],
  imports: [
    InputsModule,
    TooltipEllipsifyModule,
    TooltipModule.forRoot(),
    GroupDropdownModule,
    LoaderModule,
    CommonModule,
    AppPaginationModule,
    CheckboxModule,
    ButtonModule,
    XrefTooltipModule,
    LoaderModule
  ]
})
export class InsightsFilterModalModule { }
